import { render, staticRenderFns } from "./data53.vue?vue&type=template&id=c5222d0e&scoped=true&"
import script from "./data53.vue?vue&type=script&lang=js&"
export * from "./data53.vue?vue&type=script&lang=js&"
import style1 from "./data53.vue?vue&type=style&index=1&id=c5222d0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5222d0e",
  null
  
)

export default component.exports